import api from "@/lib/axios";

export const calendlyEvent = {
  getCalendlyEvents: async (vacancyStatusId, params) => {
    try {
      const filteredParams = Object.fromEntries(
        Object.entries(params).filter(([_, value]) => value !== null && value !== '')
      );
      const response = await api.get(`/vacancy-status/${vacancyStatusId}/events`, { params: filteredParams });
      return response.data;
    } catch (error) {
      throw new Error(`Failed to fetch events for vacancy status ${vacancyStatusId}: ${error.message}`);
    }
  },

  getRecruiters: async (vacancyId) => {
    try {
      const response = await api.get('/recruiters/listing', { params: { vacancy_id: vacancyId } });
      return response.data;
    } catch (error) {
      throw new Error(`Failed to fetch recruiters for vacancy ${vacancyId}: ${error.message}`);
    }
  },

  assignEvent: async (recruiterId, eventId) => {
    try {
      const response = await api.post("/assign/event", {
        recruiter_id: recruiterId,
        event_id: eventId
      });
      return response.data;
    } catch (error) {
      throw new Error(`Failed to assign event: ${error.message}`);
    }
  },
  
};

